export class Profit {
    dollar: number;
    percent: number;
    rows: number;
    dollarDisplay: string;
    percentDisplay: string;
}
